const userDataTemplate = {
  userName: "",
  email: "",
  photoCursor: false,
  accidentalCalendarColors: false,
  calendarActions: {},
  currentActions: [],
  friends: [],
  tutorialIsDone: false,
  smallWidgets: [],
  language: "",
  photoURL: "",
};

export default userDataTemplate;
